export default __webpack_public_path__ + "static/who-img-7322aec8a25898baba02208f198edd39.png";